module.exports = __webpack_public_path__ + "img/folder.89fcc2ee.svg";